import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import initLogging from "./logger";
import Keycloak from "keycloak-js";
import keycloakStore from "@/businesslogic/stores/keycloakStore";
import Logger from "js-logger";
import { createPinia } from "pinia";
import piniaPersist from "pinia-plugin-persist";

require("./assets/styles/styles.css");
require("./assets/themes/gevTheme/gevCSS.scss");
if (location.hostname.indexOf("gev-versicherung") >= 0) {
  require("./assets/scripts/cookieOptin.js"); //CookieOptin nur auf TEST und PROD
}
require("./assets/scripts/iFrame-resizerContent.min.js");

const kc: any = Keycloak({
  url: process.env.VUE_APP_KEYCLOAK_AUTH_URL,
  realm: process.env.VUE_APP_KEYCLOAK_AUTH_REALM,
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
});

const minValidityInSecs = 280;
const timeoutInSecs = 60000;

const pinia = createPinia();
pinia.use(piniaPersist);

kc.init({
  onLoad: "check-sso",
})
  .then(() => {
    initLogging();

    createApp(App)
      .use(pinia)
      .use(router)
      .use(kc)
      .use(VueAxios, axios)

      .mount("#app");

    console.debug("main.ts keycloak INIT DONE", kc);

    keycloakStore().setKeycloakData(kc);
    localStorage.setItem("user-token", kc.token);

    setInterval(() => {
      // Wenn man sich in der Direkt-Antragsstrecke befindet, soll der Token nicht aktualisiert werden.
      // Dieser Check gibt es um unnötige Fehlermeldungen zu vermeiden.
      if (kc.token !== undefined) {
        kc.updateToken(minValidityInSecs)
          .then((refreshed: boolean) => {
            if (refreshed) {
              localStorage.setItem("user-token", kc.token);
            } else {
              Logger.warn(
                "Token nicht aktualisiert, gültig für weitere " +
                  Math.round(kc.tokenParsed.exp + kc.timeSkew - new Date().getTime() / 1000) +
                  " Sekunden.",
              );
            }
          })
          .catch(() => {
            Logger.warn("Token konnte nicht aktualisiert werden.");
          });
      }
    }, timeoutInSecs);
  })
  .catch((error: any) => {
    Logger.warn("Fehler bei der Authentifizierung:", error);
  });
